import { atom } from 'recoil';
import { AsyncLoadStatus } from '../../common/types';
import { KpiGroupRow } from './actuality.types';

const getKey = (key: string) => `actuality-kpi-metrics-table-${key}`;

export const actualityKpiMetricsTableDataState = atom<{
  searchValues: Record<string, string>;
}>({
  key: getKey('data-state'),
  default: {
    searchValues: {},
  },
});

export const actualityKpiMetricsTableDataLoadStatus = atom<AsyncLoadStatus>({
  key: getKey('data-load-status'),
  default: AsyncLoadStatus.None,
});

export const actualityKpiMetricsTableData = atom<KpiGroupRow[]>({
  key: getKey('data'),
  default: [],
});

export const actualityKpiMetricsTableTotalCount = atom<number>({
  key: getKey('total-count'),
  default: 0,
});
